import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import SEO from "../Seo";
import { ToastContainer, toast } from "react-toastify";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { thirdparty } from "../..";
import "../../component/admin/MultipleReactQuillEditor";
import { MultipleReactQuillEditor } from "../../component/admin/MultipleReactQuillEditor";
import { IMAGE_URL } from "../../constants";

import VirtualizedSelect from "react-virtualized-select";

import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";

const CaseStudies_update = (props) => {
  const [doctors, setDoctor] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    short_description: "",
    description: "",
    featured_image: null,
    gallery: [],
    doctor_id: "",
    status: 1,
  });
  console.log(formData, "FORM_DATA");

  const fetchData = async () => {
    try {
      const response = await thirdparty.get(
        `/case_studies/${props.match.params.id}`
      );
      
      setFormData({
        ...formData,
        ...response.data,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDoctor = async (e) => {
    try {
      const response = await thirdparty.get("/doctors/getdoctors");
      if (response.status === 200) {
        setDoctor(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "doctor_id") {
      // Check if the select element is for doctor_id
      setFormData({
        ...formData,
        doctor_id: value,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // Check if a file was selected
    if (file) {
      // Update the formData state by setting the author_profile_pic to the selected file
      setFormData({
        ...formData,
        featured_image: file,
      });
    }
  };
  const handleGalleryChange = (e) => {
    setFormData({
      ...formData,
      "gallery[]": e.target.files,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // return;
      const response = await thirdparty.post(
        `/case_studies/${props.match.params.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        toast.success("Case Study update successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });

        window.location.reload();
      }
      
    } catch (error) {
      console.error("Error submitting form:", error);
      // Handle errors, show error messages, etc.
    }
  };
  useEffect(() => {
    fetchDoctor();
    fetchData();
  }, []);
  return (
    <div className="fixed-left">
      <SEO
        title="Edit Case Study"
        description="Edit Case Study  - United Hospital"
        pathSlug="/admin/case_studies_update"
        keywords="Edit Case Study, Case Study"
      />
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper row">
              <div className="col-lg-12">
                <div className="card m-b-20">
                  <div className="card-body">
                    <form
                      id="adddepartmentform"
                      className="needs-validation"
                      noValidate
                      onSubmit={handleSubmit}
                    >
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              id="title"
                              value={formData.title}
                              onChange={handleChange}
                              required
                              placeholder="Name"
                            />
                          </div>
                        </div>

                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Doctors Name</label>
                            <VirtualizedSelect
                              id="author_id"
                              name="doctor_id"
                              className="form-control custom_select_search"
                              placeholder="Select Doctor"
                              options={doctors.map((item, index) => ({
                                label: item.doctor_name,
                                value: item.id,
                              }))}
                              value={formData.doctor_id}
                              onChange={(selectValue) =>
                                setFormData({
                                  ...formData,
                                  doctor_id: selectValue.value,
                                })
                              }
                            ></VirtualizedSelect>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Feature Image</label>
                            <input
                              type="file"
                              className="form-control"
                              name="featured_image"
                              id="featured_image"
                              onChange={handleFileChange}
                              accept="image/*" // Specify the accepted file types if needed
                              placeholder="Feature Image"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Short Description</label>
                            <textarea
                              className="form-control"
                              name="short_description"
                              id="short_description"
                              value={formData.short_description}
                              onChange={handleChange}
                              required
                              placeholder="Write Summery"
                              rows={4}
                              cols={40}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Description</label>
                            <textarea
                              className="form-control"
                              name="description"
                              id="description"
                              value={formData.description}
                              onChange={handleChange}
                              required
                              placeholder="Write Summery"
                              rows={4}
                              cols={40}
                            />
                            {/* <MultipleReactQuillEditor
                              name="description"
                              id="description"
                              value={formData.description}
                              // placeholder="Write in details"
                              onChange={(name, val) =>
                                setFormData({ ...formData, [name]: val })
                              }
                            /> */}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Gallery</label>
                            <input
                              type="file"
                              className="form-control"
                              name="gallery[]"
                              id="gallery"
                              onChange={handleGalleryChange}
                              accept="image/*" // Specify the accepted file types if needed
                              placeholder="Feature Image"
                              multiple="multiple"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <div>
                          <button
                            type="submit"
                            className="btn waves-effect waves-light"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mb-20">
                  <div className="card-header">Featured Images</div>
                  <div className="card-body">
                    {formData.featured_image != null ? (
                      <img
                        src={IMAGE_URL + "/" + formData.featured_image}
                        alt=""
                        className="image-fluid p-2"
                        width={250}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-9">
                <div className="card mb-20">
                  <div className="card-header">Images</div>
                  <div className="card-body">
                    {formData.gallery && formData.gallery.length > 0
                      ? formData.gallery.map((image) => (
                        <img
                          src={IMAGE_URL + "/" + image}
                          alt=""
                          className="image-fluid p-2"
                          width={250}
                          key={image}
                        />
                      ))
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default CaseStudies_update;



// WEBPACK FOOTER //
// ./src/component/admin/CaseStudies_update.js